var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", [
      _vm._v(
        _vm._s(
          _vm.t("suspicious_login", "Classifier model statistics") +
            " (" +
            this.addressType +
            ")"
        )
      )
    ]),
    _vm._v(" "),
    !_vm.stats.active || _vm.models.length === 0
      ? _c("p", [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.t(
                  "suspicious_login",
                  "No classifier model has been trained yet. This most likely means that you just enabled the app recently. Because the training of a model requires good data, the app waits until logins of at least {days} days have been captured.",
                  {
                    days: _vm.stats.trainingDataConfig.maxAge
                  }
                )
              ) +
              "\n\t"
          )
        ])
      : _c(
          "p",
          [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.t(
                    "suspicious_login",
                    "During evaluation, the latest model (trained {time}) has shown to capture {recall}% of all suspicious logins (recall), whereas {precision}% of the logins classified as suspicious are indeed suspicious (precision). Below you see a visualization of historic model performance.",
                    {
                      time: _vm.relativeModified(_vm.models[0].createdAt),
                      precision: _vm.models[0].precisionN * 100,
                      recall: _vm.models[0].recallN * 100
                    }
                  )
                ) +
                "\n\t\t"
            ),
            _c("ModelPerformanceChart", {
              attrs: { models: _vm.models, styles: _vm.chartStyles }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }